import type {LabeledIdentified, PortaroState, ViewableSettingChain} from 'typings/portaro.be.types';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type ServerStateDataService from '../../util/server-state.data-service';
import type {SettingSectionsDataService} from '../../commons/data-services/setting-sections.data-service';
import {getFirstById} from 'shared/utils/array-utils.fp';
import type {SettingsService} from './settings.service';


export default class SettingsController {
    public static readonly controllerName = 'settingsController';

    public settings: ViewableSettingChain[];
    public serverState: PortaroState;
    public sections: LabeledIdentified<string>[];
    private activeSection: LabeledIdentified<string> = null;

    /*@ngInject*/
    constructor(private settingSectionDataService: SettingSectionsDataService,
                private settingsService: SettingsService,
                serverStateDataService: ServerStateDataService) {

        serverStateDataService.getServerState()
            .then((serverState) => this.serverState = serverState);

        settingSectionDataService.getAll()
            .then((sections) => {
                this.sections = sections;
                const sectionToShow = getFirstById('OPAC', sections[0])(sections);
                return this.setActiveSection(sectionToShow);
            });
    }

    public init() {
        angular.extend(this, window.model);
    }

    @ngAsync()
    public async setActiveSection(section: LabeledIdentified<string>) {
        this.activeSection = null;
        this.settings = await this.settingsService.getSettings(section.id);
        this.activeSection = section;
    }
}